import type { NFTCollateralPosition } from "@stepfinance/lending";
import { ExtraBoldText, StepAssetBreakdownPopoverChip } from "@stepfinance/react";
import type { FC } from "react";

import type { CommonStrings, NFTLendingStrings } from "../../../contexts/language/languageTypes";
import { daysToYearsAndRemainingDayStr } from "../../../utils/utils";
import { APRBreakdownInfo } from "../../shared";
import CellValue from "../../Table/CellValue";

interface NFTLendingPopoverProps {
  record: NFTCollateralPosition;
  common: CommonStrings;
  nftLending: NFTLendingStrings;
}

export const NFTLendingPopover: FC<NFTLendingPopoverProps> = ({ record, common, nftLending }) => {
  return (
    <StepAssetBreakdownPopoverChip
      onlyContent={true}
      title={nftLending.loanInfo}
      content={() => {
        const { durationDays, status, interestAmount } = record;
        const { yearStr, totalDurationStr } = daysToYearsAndRemainingDayStr(durationDays, common);
        return (
          <>
            <APRBreakdownInfo width={yearStr ? 248 : 212}>
              <div>
                <ExtraBoldText>{nftLending.duration}</ExtraBoldText>
                <CellValue cellType="number">{totalDurationStr}</CellValue>
              </div>
              <div>
                <ExtraBoldText>{nftLending.status}</ExtraBoldText>
                <CellValue cellType="text">{nftLending.loanStatus[status]}</CellValue>
              </div>
              <div>
                <ExtraBoldText>{nftLending.interest}</ExtraBoldText>
                <CellValue cellType="number">{interestAmount.toFixed(2) + " SOL"}</CellValue>
              </div>
            </APRBreakdownInfo>
          </>
        );
      }}
    />
  );
};
